// GW's undergraduate majors (#2596, founder 2026-09-30: "majors offered by the
// college in the public page"). Read on 2026-09-30 from the official GW Bulletin's
// Find Your Program page (bulletin.gwu.edu/find-your-program/), the page GW's
// admissions Academics page links as "Find Your Major": every program tagged
// Undergraduate Major in the seven schools that admit first-year students, under
// the school the Bulletin tags. Corcoran and SMPA programs, also tagged Columbian
// College, sit under Corcoran and SMPA only. Left out: concentrations and options
// inside a listed major, International Affairs concentrations, combined
// bachelor's/master's programs, minors, and programs of schools that do not admit
// first-year students (Medicine and Health Sciences, Nursing, Professional
// Studies). Flags quote the First Year Applicants page (the college file's
// `firstYear` source). Typography is plain ASCII. The KB's majors list was the
// starting point; the Bulletin wins.
const majors = {
    "slug": "george-washington-university",
    "read": "2026-09-30",
    "intro": "Every undergraduate major in GW's official Bulletin at the seven schools that admit first-year students, grouped by school, with the degree it leads to. Concentrations, minors and combined graduate programs are left out.",
    "groups": [
        {
            "name": "Columbian College of Arts and Sciences",
            "source": {
                "label": "GW Bulletin, Find Your Program, Columbian College of Arts and Sciences",
                "url": "https://bulletin.gwu.edu/find-your-program/#filter=.filter_30&.filter_15"
            },
            "majors": [
                {
                    "name": "Africana Studies",
                    "degree": "BA"
                },
                {
                    "name": "American Studies",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Arabic Studies",
                    "degree": "BA"
                },
                {
                    "name": "Archaeology",
                    "degree": "BA"
                },
                {
                    "name": "Astronomy and Astrophysics",
                    "degree": "BS"
                },
                {
                    "name": "Biological Anthropology",
                    "degree": "BS"
                },
                {
                    "name": "Biology",
                    "degree": "BA"
                },
                {
                    "name": "Biology",
                    "degree": "BS"
                },
                {
                    "name": "Biophysics",
                    "degree": "BS"
                },
                {
                    "name": "Business Analytics (STEM)",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Chinese Language and Literature",
                    "degree": "BA"
                },
                {
                    "name": "Classical and Ancient Near Eastern Studies",
                    "degree": "BA"
                },
                {
                    "name": "Cognitive Neuroscience",
                    "degree": "BS"
                },
                {
                    "name": "Cognitive Science of Language",
                    "degree": "BS"
                },
                {
                    "name": "Communication",
                    "degree": "BA"
                },
                {
                    "name": "Criminal Justice",
                    "degree": "BA"
                },
                {
                    "name": "Data Science",
                    "degree": "BS"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "BS"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "English and Creative Writing",
                    "degree": "BA"
                },
                {
                    "name": "Environmental and Sustainability Science",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Studies",
                    "degree": "BA"
                },
                {
                    "name": "French Language, Literature, and Culture",
                    "degree": "BA"
                },
                {
                    "name": "Geography",
                    "degree": "BA"
                },
                {
                    "name": "Geological Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Geological Sciences",
                    "degree": "BS"
                },
                {
                    "name": "German Language and Literature",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "Human Services and Social Justice",
                    "degree": "BA"
                },
                {
                    "name": "Japanese Language and Literature",
                    "degree": "BA"
                },
                {
                    "name": "Judaic Studies",
                    "degree": "BA"
                },
                {
                    "name": "Korean Language and Literature",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Neuroscience",
                    "degree": "BS"
                },
                {
                    "name": "Organizational Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Peace Studies",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy (Public Affairs Focus)",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Political Science",
                    "degree": "BS"
                },
                {
                    "name": "Political Science (Public Policy Focus)",
                    "degree": "BA"
                },
                {
                    "name": "Psychological and Brain Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Psychological and Brain Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Religion",
                    "degree": "BA"
                },
                {
                    "name": "Russian Language and Literature",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Spanish and Latin American Languages, Literatures, and Cultures",
                    "degree": "BA"
                },
                {
                    "name": "Speech, Language, and Hearing Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Statistics",
                    "degree": "BS"
                },
                {
                    "name": "Women's, Gender, and Sexuality Studies",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Corcoran School of the Arts and Design",
            "source": {
                "label": "GW Bulletin, Find Your Program, Corcoran School of the Arts and Design",
                "url": "https://bulletin.gwu.edu/find-your-program/#filter=.filter_30&.filter_40"
            },
            "majors": [
                {
                    "name": "Art History",
                    "degree": "BA"
                },
                {
                    "name": "Dance",
                    "degree": "BA"
                },
                {
                    "name": "Fine Arts",
                    "degree": "BA"
                },
                {
                    "name": "Fine Arts",
                    "degree": "BFA",
                    "flag": "A portfolio review of 12 to 20 completed works of art, sent through SlideRoom under the same major as your application.",
                    "flagSource": "firstYear"
                },
                {
                    "name": "Graphic Design",
                    "degree": "BFA",
                    "flag": "A portfolio review of 12 to 20 completed works of art, sent through SlideRoom under the same major as your application.",
                    "flagSource": "firstYear"
                },
                {
                    "name": "Interaction Design",
                    "degree": "BA"
                },
                {
                    "name": "Interaction Design",
                    "degree": "BFA",
                    "flag": "A portfolio review of 12 to 20 completed works of art, sent through SlideRoom under the same major as your application.",
                    "flagSource": "firstYear"
                },
                {
                    "name": "Interior Architecture",
                    "degree": "BFA"
                },
                {
                    "name": "Music",
                    "degree": "BA"
                },
                {
                    "name": "Photojournalism",
                    "degree": "BFA",
                    "flag": "A portfolio review of 12 to 20 completed works of art, sent through SlideRoom under the same major as your application.",
                    "flagSource": "firstYear"
                },
                {
                    "name": "Theatre",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "School of Media and Public Affairs",
            "source": {
                "label": "GW Bulletin, Find Your Program, School of Media and Public Affairs",
                "url": "https://bulletin.gwu.edu/find-your-program/#filter=.filter_30&.filter_42"
            },
            "majors": [
                {
                    "name": "Journalism and Mass Communication",
                    "degree": "BA"
                },
                {
                    "name": "Political Communication",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Elliott School of International Affairs",
            "source": {
                "label": "GW Bulletin, Find Your Program, Elliott School of International Affairs",
                "url": "https://bulletin.gwu.edu/find-your-program/#filter=.filter_30&.filter_23"
            },
            "majors": [
                {
                    "name": "Asian Studies",
                    "degree": "BA"
                },
                {
                    "name": "International Affairs",
                    "degree": "BA"
                },
                {
                    "name": "International Affairs",
                    "degree": "BS"
                },
                {
                    "name": "Latin American and Hemispheric Studies",
                    "degree": "BA"
                },
                {
                    "name": "Middle East Studies",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "GW School of Business",
            "source": {
                "label": "GW Bulletin, Find Your Program, GW School of Business",
                "url": "https://bulletin.gwu.edu/find-your-program/#filter=.filter_30&.filter_16"
            },
            "majors": [
                {
                    "name": "Accountancy",
                    "degree": "BS"
                },
                {
                    "name": "Business",
                    "degree": "BS"
                },
                {
                    "name": "Entrepreneurship and Innovation",
                    "degree": "BS"
                },
                {
                    "name": "Finance",
                    "degree": "BS"
                },
                {
                    "name": "Information Systems",
                    "degree": "BS"
                },
                {
                    "name": "International Business",
                    "degree": "BS"
                },
                {
                    "name": "Marketing",
                    "degree": "BS"
                },
                {
                    "name": "Strategic Management and Public Policy",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "School of Engineering and Applied Science",
            "source": {
                "label": "GW Bulletin, Find Your Program, School of Engineering and Applied Science",
                "url": "https://bulletin.gwu.edu/find-your-program/#filter=.filter_30&.filter_18"
            },
            "majors": [
                {
                    "name": "Biomedical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BA"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Systems Engineering",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Milken Institute School of Public Health",
            "source": {
                "label": "GW Bulletin, Find Your Program, Milken Institute School of Public Health",
                "url": "https://bulletin.gwu.edu/find-your-program/#filter=.filter_30&.filter_22"
            },
            "majors": [
                {
                    "name": "Exercise Science",
                    "degree": "BS"
                },
                {
                    "name": "Health Data Science",
                    "degree": "BS"
                },
                {
                    "name": "Nutrition",
                    "degree": "BS"
                },
                {
                    "name": "Public Health",
                    "degree": "BS"
                }
            ]
        }
    ]
};

export default majors;
